import classNames from 'classnames';
import React from 'react';
import { Card } from 'react-bootstrap';
import { useGetDta } from '../../hooks/useGetDta';
import { htmlTxt } from '../../helpers/details';
const baseUrl = process.env.REACT_APP_API;

const ItemTik = ({ id, data }) => {
    const { data: tks } = useGetDta(`tickets/ticket/${id}`);

    return (
        <>
            {tks.map((tk) => (
                <Card className="mb-2" key={tk.id}>
                    <Card.Header className="bg-light">
                        {' '}
                        <small className="float-end "> {tk.fecha_hora}</small>
                        <span className={classNames('badge bg-primary')}>Respuesta</span>
                    </Card.Header>
                    <Card.Body className="p-3">
                        <h5 className="mt-2 mb-2"> {htmlTxt(tk.contenido)}</h5>
                        <p className="mb-0">
                            {tk.adjunto && (
                                <img src={`${baseUrl}${tk.adjunto}`} alt="adjuntoTk" style={{ width: '150px' }} />
                            )}
                        </p>
                    </Card.Body>
                    <Card.Footer>
                        <span className=" text-uppercase">{tk.state === 0 ? 'Cliente' : 'Agente'}</span>
                        <span className="float-end"> {tk.state === 1 ? tk?.agente : data?.cliente}</span>
                    </Card.Footer>
                </Card>
            ))}
        </>
    );
};

export default ItemTik;
